<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><i>Play It Forward</i></p>
<p class="ded"><i>This book is dedicated to the loving memory of Professor Rod Moag. His research on bluegrass music in Texas as well as his assistance on our first book,</i> Texas Bluegrass History, <i>will forever be appreciated by us.</i></p>
<p class="ded"><i>—Braeden Paul and Jeff Campbell</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?4842f6aa